import { render } from "./ChartBasicCriteria.vue?vue&type=template&id=1263986f&scoped=true"
import script from "./ChartBasicCriteria.vue?vue&type=script&lang=js"
export * from "./ChartBasicCriteria.vue?vue&type=script&lang=js"

import "./ChartBasicCriteria.vue?vue&type=style&index=0&id=1263986f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1263986f"]])

export default __exports__